module.exports = __webpack_public_path__ + "static/media/mmume_01.4435153a.png";